import { ContentActionTypes } from './types';
import { createAsyncAction, createAsyncMapAction } from '~lib/shared/redux/actions';
export const getSegment = createAsyncMapAction(ContentActionTypes.GET_SEGMENT, p => p.segment);
export const getPages = createAsyncAction(ContentActionTypes.GET_PAGES);
export const getDocumentBase = createAsyncAction(ContentActionTypes.GET_DOCUMENT_BASE);
